

    export default {
        name: "FiveStarInsurerTitleWithCategoryButtonSection",
        props: {
            data: {
                type: Array,
                default: () => ([])
            },
            title: {
                type: String
            },
        },
        data() {
            return {}
        },
        computed: {},
        mounted() {},
        methods: {},
    }
